module.exports = __webpack_public_path__ + "01_very_short_brown.e06e91af.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_very_short_brown.png
// module id = 0U5X
// module chunks = 0